import { ActionTypes } from "../../constants/ActionTypes";
import {
  IDataNode,
  IEmployeePositionFolders,
  IEmployeePositionFoldersReducer,
  IFolderModelResponse,
} from "../../interfaces";

const INIT_STATE: IEmployeePositionFoldersReducer = {
  inboxEmployeePositionFolders: [],
  sendBoxEmployeePoisitionFolders: [],
  draftBoxEmployeePoisitionFolders: [],
  trashEmployeePoisitionFolders: [],
  cartableCount: 0,
};

function updateTreeData(
  list: IDataNode[],
  key: React.Key,
  children: IDataNode[]
): IDataNode[] {
  return list.map((node) => {
    if (node.key === key) {
      return {
        ...node,
        children,
      };
    } else if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children),
      };
    }

    return node;
  });
}

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CLEAR_INBOX_EMPLOYEE_POSITION_FOLDERS: {
      return {
        ...state,
        inboxEmployeePositionFolders: [],
        inboxEmployeePositionFoldersLoading: false,
      };
    }

    case ActionTypes.FETCH_INBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS: {
      let lstTemp: IEmployeePositionFolders[] = [];
      let { cartableCount } = state;
      action.payload.map((item: IFolderModelResponse) => {
        if (item.folderId === 0) {
          cartableCount = item.unreadCount;
        } else {
          if (item.name)
            lstTemp.push({
              archiveId: null,
              title:
                item.unreadCount > 0
                  ? `${item.name} (${item.unreadCount})`
                  : item.name,
              key: item.folderId,
              isLeaf: !item.hasChild,
              parentId: item.parentId,
            });
        }
      });
      let newTree;
      if (lstTemp[0]?.parentId) {
        newTree = updateTreeData(
          state.inboxEmployeePositionFolders as IDataNode[],
          lstTemp[0].parentId,
          lstTemp
        );
      } else newTree = lstTemp;
      return {
        ...state,
        // cartableCount: rootCount,
        cartableCount,
        inboxEmployeePositionFolders: newTree,
        inboxEmployeePositionFoldersLoading: false,
      };
    }

    case ActionTypes.GET_INBOX_EMPLOYEE_POSITION_FOLDERS: {
      return {
        ...state,
        inboxEmployeePositionFoldersLoading: true,
      };
    }

    // SendBox
    case ActionTypes.CLEAR_SENDBOX_EMPLOYEE_POSITION_FOLDERS: {
      return {
        ...state,
        sendBoxEmployeePoisitionFoldersLoading: false,
      };
    }

    case ActionTypes.FETCH_SENDBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS: {
      let lstTemp: IEmployeePositionFolders[] = [];
      action.payload.map((item: IFolderModelResponse) => {
        if (item.name)
          lstTemp.push({
            archiveId:null,
            // title: item.letterUnreadCount > 0 ? `${item.name} (${item.letterUnreadCount})` : item.name,
            title: item.name,
            key: item.folderId,
            isLeaf: !item.hasChild,
            parentId: item.parentId,
          });
      });

      let newTree;
      if (lstTemp[0]?.parentId) {
        newTree = updateTreeData(
          state.sendBoxEmployeePoisitionFolders as IDataNode[],
          lstTemp[0].parentId,
          lstTemp
        );
      } else newTree = lstTemp;

      return {
        ...state,
        sendBoxEmployeePoisitionFolders: newTree,
        sendBoxEmployeePoisitionFoldersLoading: false,
      };
    }

    case ActionTypes.GET_SENDBOX_EMPLOYEE_POSITION_FOLDERS: {
      return {
        ...state,
        sendBoxEmployeePoisitionFoldersLoading: true,
      };
    }
    //Draft
    case ActionTypes.FETCH_Draft_EMPLOYEE_POSITION_fOLDERS_SUCCESS: {
      let lstTemp: IEmployeePositionFolders[] = [];
      action.payload.map((item: IFolderModelResponse) => {
        if (item.name)
          lstTemp.push({
            archiveId:null,
            title:
              item.unreadCount > 0
                ? `${item.name} (${item.unreadCount})`
                : item.name,
            key: item.folderId,
            isLeaf: !item.hasChild,
            parentId: item.parentId,
          });
      });

      let newTree;
      if (lstTemp[0]?.parentId) {
        newTree = updateTreeData(
          state.draftBoxEmployeePoisitionFolders as IDataNode[],
          lstTemp[0].parentId,
          lstTemp
        );
      } else newTree = lstTemp;

      return {
        ...state,
        draftBoxEmployeePoisitionFolders: newTree,
        draftEmployeePoisitionFoldersLoading: false,
      };
    }

    case ActionTypes.GET_Draft_EMPLOYEE_POSITION_FOLDERS: {
      return {
        ...state,
        draftEmployeePoisitionFoldersLoading: true,
      };
    }
    case ActionTypes.GET_TRASH_EMPLOYEE_POSITION_FOLDERS: {
      return {
        ...state,
        trashEmployeePoisitionFoldersLoading: true,
      };
    }
    case ActionTypes.FETCH_TRASH_EMPLOYEE_POSITION_fOLDERS_SUCCESS: {
      let lstTemp: IEmployeePositionFolders[] = [];
      action.payload.map((item: IFolderModelResponse) => {
        if (item.name)
          lstTemp.push({
            archiveId:null,
            title:
              item.unreadCount > 0
                ? `${item.name} (${item.unreadCount})`
                : item.name,
            key: item.folderId,
            isLeaf: !item.hasChild,
            parentId: item.parentId,
          });
      });

      let newTree;
      if (lstTemp[0]?.parentId) {
        newTree = updateTreeData(
          state.trashEmployeePoisitionFolders as IDataNode[],
          lstTemp[0].parentId,
          lstTemp
        );
      } else newTree = lstTemp;

      return {
        ...state,
        trashEmployeePoisitionFolders: newTree,
        trashEmployeePoisitionFoldersLoading: false,
      };
    }

    default:
      return state;
  }
};
